<template>
  <v-card typeof="Course" class="card rounded-xl" @click="cardClicked()">
    <v-img :src="image" height="200px" class="bg-img"> </v-img>
    <div class="px-6 py-5" style="display: flex; flex-direction: column">
      <span class="font-weight-light grey--text mb-1">Prof. Lucas Silva</span>
      <h3
        class="primary--text"
        style="line-height: 1; font-weight: bold"
        property="name"
      >
        {{ courseName }}
      </h3>
      <div class="description" property="description">
        {{ description }}
      </div>
      <DisplayPrice :price="price" :anchor="anchor"></DisplayPrice>
      <v-btn
        rounded
        color="primary"
        elevation="0"
        style="
          width: 100%;
          font-weight: bold;
          font-size: 16px;
          margin-top: 18px;
        "
        >Comprar</v-btn
      >
    </div>
  </v-card>
</template>

<script>
import DisplayPrice from "./DisplayPrice.vue";

export default {
  name: "ShoppingCard",
  components: { DisplayPrice },
  props: {
    courseId: Number,
    courseName: String,
    image: String,
    description: String,
    anchor: String,
    price: String,
  },
  methods: {
    cardClicked() {
      this.$emit("card-clicked", this.courseId);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  cursor: pointer;
}
.bg-img {
  background-color: #15273d;
}
.description {
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  min-height: 85px;
  max-height: 85px;
  font-size: 18px;
  margin-top: 14px;
}
</style>
